import { render, staticRenderFns } from "./Led.vue?vue&type=template&id=1ef65708&scoped=true&"
import script from "./Led.vue?vue&type=script&lang=js&"
export * from "./Led.vue?vue&type=script&lang=js&"
import style0 from "./Led.vue?vue&type=style&index=0&id=1ef65708&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef65708",
  null
  
)

export default component.exports